import { Button, styled } from '@mui/material'

export const ActionButton = styled(Button)(({ theme }) => ({
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        width: '100%',
    },
}))
